export default async function extractCodeError(error: unknown, fallbackMessage: string): Promise<string> {
  if (error && typeof error === 'object' && 'response' in error) {
    const data = await (error as { response: Response }).response.json();
    return data?.code || data?.error || gettext('Invalid code');
  }
  return fallbackMessage;
}
